import type { ComponentType } from 'react';
import {
  ArrowLeft,
  ArrowUpRight,
  Briefcase,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  Clock,
  CloudUpload,
  Code,
  Coins,
  Copy,
  CreditCard,
  Database,
  ExternalLink,
  Eye,
  FileCode,
  Folder,
  Globe,
  GripVertical,
  Image,
  Inbox,
  Info,
  Layers,
  LayoutTemplate,
  Link,
  List,
  LoaderCircle,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Palette,
  Pencil,
  Phone,
  Plug,
  Plus,
  Power,
  RefreshCw,
  Rocket,
  RotateCcwClock,
  Save,
  Search,
  Send,
  Settings,
  Share2,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Star,
  Ticket,
  Trash2,
  TriangleAlert,
  Type,
  Upload,
  User,
  Wallet,
  X,
} from 'lucide-react';
import { BagMark, DomainMark, GramMark, TelegramMark, TonMark } from './marks.js';

export interface IconRenderProps {
  width?: number | string;
  height?: number | string;
  strokeWidth?: number | string;
  className?: string;
  'aria-hidden'?: boolean;
}

export type IconComponent = ComponentType<IconRenderProps>;

export const ICONS = {
  ton: TonMark,
  gram: GramMark,
  telegram: TelegramMark,
  bag: BagMark,
  domain: DomainMark,
  globe: Globe,
  wallet: Wallet,
  connect: Plug,
  disconnect: Power,
  'log-out': LogOut,
  coins: Coins,

  template: LayoutTemplate,
  code: Code,
  file: FileCode,
  folder: Folder,
  image: Image,
  palette: Palette,
  text: Type,
  layers: Layers,
  settings: Settings,
  publish: Rocket,
  preview: Eye,
  save: Save,
  edit: Pencil,
  upload: Upload,
  'cloud-upload': CloudUpload,
  storage: Database,
  history: RotateCcwClock,
  sparkles: Sparkles,

  card: CreditCard,
  links: Link,
  briefcase: Briefcase,
  star: Star,
  ticket: Ticket,

  user: User,
  mail: Mail,
  phone: Phone,
  'map-pin': MapPin,
  calendar: Calendar,
  send: Send,
  inbox: Inbox,
  share: Share2,

  check: Check,
  success: CircleCheck,
  warning: TriangleAlert,
  error: CircleAlert,
  info: Info,
  spinner: LoaderCircle,
  clock: Clock,
  shield: ShieldCheck,
  lock: Lock,

  close: X,
  plus: Plus,
  trash: Trash2,
  copy: Copy,
  refresh: RefreshCw,
  search: Search,
  list: List,
  drag: GripVertical,
  back: ArrowLeft,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  'chevron-down': ChevronDown,
  'external-link': ExternalLink,
  'open-external': ArrowUpRight,
  mobile: Smartphone,
} satisfies Record<string, IconComponent>;

export type IconName = keyof typeof ICONS;

export const ICON_NAMES = Object.keys(ICONS) as IconName[];

export function isIconName(value: unknown): value is IconName {
  return typeof value === 'string' && value in ICONS;
}
